import { usePreserveSearchParamsNavigate } from "../../hooks/usePreserveSearchParamsNavigate.ts";
import { BOARDS, WORKSPACES } from "../../routes.ts";
import { boardStatePresetStore } from "../boardState/boardStatePresetStore.ts";
import type { BoardState, StatePreset } from "../boardState/types.ts";
import { useWorkspaceUuid } from "./useWorkspaceUuid.ts";

export const useRedirectToBoard = () => {
  const navigate = usePreserveSearchParamsNavigate();
  const workspaceUuid = useWorkspaceUuid();
  return ({
    uuid,
    boardStatePreset,
    baseBoardState,
  }: {
    uuid: string;
    boardStatePreset: StatePreset;
    baseBoardState?: Partial<BoardState>;
  }) => {
    boardStatePresetStore.setBoardStatePreset({
      boardUuid: uuid,
      boardStatePreset,
      baseBoardState,
    });
    navigate(`${WORKSPACES}/${workspaceUuid}/${BOARDS}/${uuid}`);
  };
};
